import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'; // Importation directe pour éviter l'erreur de fonction

export const generateInvoicePDF = (invoice, user) => {
  const doc = new jsPDF();
  const themeColor = [46, 125, 50]; // Vert NSARA

  // En-tête Entreprise
  doc.setFontSize(20);
  doc.setTextColor(themeColor[0], themeColor[1], themeColor[2]);
  doc.text(user.nom || "NSARA", 14, 22);
  
  doc.setFontSize(10);
  doc.setTextColor(100);
  doc.text(`Email: ${user.email}`, 14, 30);
  doc.text(`Tel: ${user.telephone || 'N/A'}`, 14, 35);

  // Infos Facture
  doc.setTextColor(0);
  doc.text(`FACTURE N°: ${invoice.numero}`, 140, 22);
  doc.text(`Date: ${new Date(invoice.date).toLocaleDateString()}`, 140, 30);

  // Client
  doc.text("CLIENT:", 14, 50);
  doc.setFont(undefined, 'bold');
  doc.text(invoice.client?.nom || "Client Divers", 14, 57);

  // Tableau des produits (Calcul de la TVA par ligne)
  const tableRows = (invoice.items || []).map(item => [
    item.description,
    item.quantite,
    `${item.prix} FCFA`,
    `${item.tva}%`,
    `${item.quantite * item.prix} FCFA`
  ]);

  autoTable(doc, {
    startY: 65,
    head: [['Désignation', 'Qté', 'P.U', 'TVA', 'Total HT']],
    body: tableRows,
    headStyles: { fillColor: themeColor },
  });

  // Totaux Automatisés
  const finalY = doc.lastAutoTable.finalY + 10;
  doc.setFontSize(10);
  doc.text(`Total HT: ${invoice.totals.ht} FCFA`, 140, finalY);
  doc.text(`Montant TVA: ${invoice.totals.tva} FCFA`, 140, finalY + 7);
  doc.setFontSize(12);
  doc.setFont(undefined, 'bold');
  doc.text(`NET À PAYER: ${invoice.totals.ttc} FCFA`, 140, finalY + 15);

  doc.save(`${invoice.numero}.pdf`);
};